import React, { useState } from "react";
import {
  Button,
  Grid,
  TextField,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import {
  DataGrid,
  GridColDef,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";

const GetTHATraxSearch = () => {
  const [data, setData] = useState<any[]>([]);
  const [search, setSearch] = useState("");
  const [days, setDays] = useState<Number>(7);
  const [pageSize, setPageSize] = useState(10);

  const [action, setAction] = useState<Boolean>(false);

  const columns: GridColDef[] = [
    {
      field: "Date",
      headerName: "Date",
      flex: 1,
      minWidth: 120,
      hideable: false,
    },
    {
      field: "Msisdn",
      headerName: "MSISDN",
      flex: 1,
      minWidth: 120,
      hideable: false,
    },
    { field: "Email", headerName: "Email", flex: 1, minWidth: 120 },
    { field: "Currency", headerName: "Currency", flex: 1, minWidth: 120 },
    {
      field: "ProductType",
      headerName: "Product Type",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "PaymentMethod",
      headerName: "Payment Method",
      flex: 1,
      minWidth: 120,
    },
    { field: "Status", headerName: "Status", flex: 1, minWidth: 120 },
    { field: "Amount", headerName: "Amount", flex: 1, minWidth: 120 },
    {
      field: "TransactionRef",
      headerName: "Transaction Ref",
      flex: 1,
      minWidth: 120,
    },
  ];
  const handleGetBundles = async () => {
    setData([]);
    toast.dismiss();
    if (search.trim() != "") {
      setAction(true);
      requestBundles();
    } else {
      toast.error("Please enter valid input.");
    }
  };

  const requestBundles = async () => {
    await axiosInterceptorInstance
      .get(
        `/ThaCrm/GetTransactionSearch?Search=${search.trim()}&Days=${days}&type=1`
      )
      .then((res: any) => {
        setAction(false);
        const apiresponse = JSON.parse(res.data.body);
        if (!apiresponse.Data || apiresponse.Data.length == 0) {
          toast.error("Record not found.");
          setData([]);
        } else {
          setData(apiresponse?.Data);
        }
      })
      .catch((error: any) => {
        setAction(false);
        toast.error(error.message);
      });
  };

  const defaultVisibility: any = {
    Date: true,
    Msisdn: true,
    Email: true,
    Currency: true,
    ProductType: false,
    PaymentMethod: false,
    Status: false,
    Amount: false,
    TransactionRef: false,
  };

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<any>(defaultVisibility);

  function CustomToolbar() {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 12,
          padding: 8,
        }}
      >
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">THA Trax Search</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                className="formControl"
                label="Search"
                variant="outlined"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                inputProps={{ maxLength: 50 }}
                helperText="Search by Msisdn, Email, or Transaction Reference"
              />
            </Grid>
            <Grid item xs={4}>
              <FormControl fullWidth>
                <InputLabel
                  id="demo-simple-select-label"
                  style={{ background: "#fff", padding: " 0 5px" }}
                >
                  Days
                </InputLabel>
                <Select
                  value={days}
                  defaultValue={days}
                  onChange={(e) => setDays(Number(e.target.value))}
                  style={{ minWidth: 150 }}
                >
                  <MenuItem value={7}>Last 7 days</MenuItem>
                  <MenuItem value={15}>Last 15 days</MenuItem>
                  <MenuItem value={30}>Last 30 days</MenuItem>
                  <MenuItem value={90}>Last 90 days</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={4}>
              {!action && (
                <Button
                  onClick={handleGetBundles}
                  className="dButton dButton2"
                  variant="contained"
                >
                  Search
                </Button>
              )}
              {action && (
                <Button className="dButton dButton2" variant="contained">
                  <CircularProgress color="inherit" size={30} />
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      </div>

      {data?.length > 0 && (
        <div style={{ height: 550, width: "100%", marginTop: 16 }}>
          <DataGrid
            rows={data?.map((row: any, index: number) => ({
              id: index + 1,
              ...row,
            }))}
            columns={columns}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
            }
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[10, 25, 50]}
            disableColumnMenu
            components={{
              Toolbar: CustomToolbar,
            }}
            getRowHeight={() => "auto"}
            sx={{
              "& .MuiDataGrid-cell": {
                whiteSpace: "normal !important", // allow wrapping
                fontSize: "0.7rem",
                wordBreak: "break-word !important",
                padding: "5px 0px 5px 25px",
              },
            }}
          />
        </div>
      )}
    </motion.div>
  );
};

export default GetTHATraxSearch;
